import { getRequest } from '../../httpClient';
import type { IListPublicChallengeVsV2Response } from './list-public-challenge-vs-v2-response';
import { listPublicChallengeVsV2ResponseSchema } from './list-public-challenge-vs-v2-response';

interface IListPublicChallengeVsV2Options {
  cursor?: string;
  limit?: number;
}

export async function listPublicChallengeVsV2Api(options?: IListPublicChallengeVsV2Options) {
  const params: Record<string, string | number> = {};
  if (options?.cursor) {
    params.cursor = options.cursor;
  }
  if (options?.limit) {
    params.limit = options.limit;
  }
  return getRequest<IListPublicChallengeVsV2Response>({
    path: '/challenges/vs/v2',
    options: Object.keys(params).length > 0 ? { params } : undefined,
    schema: listPublicChallengeVsV2ResponseSchema,
  });
}
